import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import styled from "styled-components"
import Prev from "../assets/images/research/icons/Prev"
import Next from "../assets/images/research/icons/Next"

const Pagination = ({ data }) => {
  const {
    previousPagePath,
    nextPagePath,
    numberOfPages,
    paginationPath,
    pageNumber,
    numPages,
    currentPage,
  } = data
  const [activePage, setActivePage] = useState(currentPage - 1 || pageNumber)
  let pages = []
  const isFirst = activePage === 0
  const isLast = activePage + 1 === numberOfPages || activePage + 1 === numPages
  const prevPage =
    currentPage - 1 === 1
      ? `${paginationPath}`
      : `${paginationPath}${currentPage - 1}`
  const nextPage = `${paginationPath}${currentPage + 1}`

  if (activePage !== undefined) {
    for (let i = 1; i <= numberOfPages || i <= numPages; i++) {
      if (
        i === 1 ||
        i === numberOfPages ||
        i === numPages ||
        (i >= activePage && i <= activePage + 2)
      ) {
        pages.push({
          label: i,
          linkURL:
            i === 1
              ? paginationPath
              : `${paginationPath.split(",")}${
                  paginationPath.split("").at(-1) !== "/" ? "/" : ""
                }${i}`,
        })
      } else if (pages[pages.length - 1] !== "...") {
        pages.push("...")
      }
    }
  }
  useEffect(() => {
    setActivePage(currentPage ? currentPage - 1 : pageNumber)
  }, [currentPage, pageNumber])

  if (numberOfPages < 2) {
    return null
  }
  return (
    <PaginationWrapper>
      <ControlsLink
        to={previousPagePath || prevPage}
        disableprev={String(isFirst)}
      >
        <Prev fill="#fff" />
        Previous
      </ControlsLink>
      <NumbersWrapper>
        {pages.map((page, index) => {
          return (
            <Link
              activeClassName="active"
              to={page.linkURL ? page.linkURL : "#"}
              key={index}
              style={{
                cursor: page === "..." ? "initial" : "pointer",
                background: page === "..." ? "initial" : "",
                pointerEvents: page === "..." ? "none" : "default",
              }}
            >
              {typeof page === "object" ? page.label : page}
            </Link>
          )
        })}
      </NumbersWrapper>
      <ControlsLink to={nextPagePath || nextPage} disablenext={String(isLast)}>
        Next
        <Next fill="#fff" />
      </ControlsLink>
    </PaginationWrapper>
  )
}

Pagination.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Pagination

export const PaginationWrapper = styled.div`
  text-align: center;
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid ${({ theme }) => theme.colors.primary_color};
  padding-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  position: relative;
  z-index: 1;
  a {
    color: #a5a5a5;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    transition: 0.3s;
    width: 22.5px;
    height: 22.5px;
    border-radius: 5px;

    @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
      font-size: 20px;
      border-radius: 8px;
      width: 40px;
      height: 40px;
    }

    &:hover {
      color: #fff;
      background-color: rgba(42, 149, 191, 0.7);
    }
  }
  a.active {
    color: white;
    background-color: ${({ theme }) => theme.colors.primary_color};
  }
`

export const ControlsLink = styled(Link)`
  border-radius: 5px;
  color: white !important;
  padding: 8px 8px;
  transition: ${({ theme }) => theme.durations.transition};
  width: max-content !important;
  background-color: ${({ theme }) => theme.colors.primary_color};

  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    padding: 8px 16px;
    border-radius: 8px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary_color}!important;
  }

  &:first-child {
    pointer-events: ${props =>
      props.disableprev === "true" ? "none" : "default"};
    opacity: ${props => (props.disableprev === "true" ? "0" : "")};

    @media (max-width: ${({ theme }) => theme.media.mobile_max}) {
      font-size: 0;

      svg {
        margin: 0 !important;
      }
    }

    svg {
      margin-right: 7px;
      transition: ${({ theme }) => theme.durations.transition};
    }

    &:hover {
      svg {
        transform: translateX(-3px);
        transition: ${({ theme }) => theme.durations.transition};
      }
    }
  }
  &:last-child {
    pointer-events: ${props =>
      props.disablenext === "true" ? "none" : "default"};
    opacity: ${props => (props.disablenext === "true" ? "0" : "")};

    @media (max-width: ${({ theme }) => theme.media.mobile_max}) {
      font-size: 0;

      svg {
        margin: 0 !important;
      }
    }

    svg {
      margin-left: 7px;
      transition: ${({ theme }) => theme.durations.transition};
    }

    &:hover {
      svg {
        transform: translateX(3px);
        transition: ${({ theme }) => theme.durations.transition};
      }
    }
  }
`

const NumbersWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`
